export default "__VITE_ASSET__317b3c04__"